"use client";

import { SOfferDto, SProduct } from "@/__generated__/graphql";
import { Add, Circle, MoreVert } from "@mui/icons-material";
import { Box, Card, CardContent, IconButton, Typography, useTheme } from "@mui/material";
import Image from "next/image";
import { memo } from "react";
import { RevealEffect } from "react-reveal-effect";
import CountdownTimer from "@/app/(main)/_components/CountdownTimer";
type Props = {
  offer?: SOfferDto;
};

function arePropsEqual<P>(prevProps: Readonly<P>, nextProps: Readonly<P>): boolean {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps);
}
function ProductCardOfferType({ offer }: Props) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        top: 8, // Adjust to fine-tune the position
        left: 8, // Adjust to fine-tune the position
        zIndex: 1, // Ensure it's on top of the image
        display: "flex",
        flexDirection: "column",
        gap: 0.2,
      }}
    >
      {offer && (
        <Box
          sx={{
            backgroundColor: "error.100",
            p: 0.5,
            px: 1,
            borderRadius: 1000,
            color: "white.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Typography variant="body2" color={"white.main"}>
            {offer.offerType.title}
          </Typography>
          <CountdownTimer endDate={offer?.end_at} isActive={!!offer} small={true} />
        </Box>
      )}
    </Box>
  );
}

export default memo(ProductCardOfferType, arePropsEqual);
